import { v4 as uuidV4 } from 'uuid';

// Utility function to generate UUID with fallback
export const generateUUID = () => {
  // Try to use native crypto.randomUUID() first
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback to uuid library
  return uuidV4();
};
